export class DispatcherMapMarkerService {
  private markersByDispatch: Record<string | number, google.maps.Marker[]> = {};

  iterateDispatches(fn: (dispatchId: string | number, markers: google.maps.Marker[]) => void) {
    Object.keys(this.markersByDispatch).forEach((dispatchId) => {
      fn(dispatchId, this.markersByDispatch[dispatchId]);
    });
  }

  clearMarkers() {
    this.iterateDispatches((_, markers) => {
      markers.forEach((marker) => marker.setMap(null));
    });
    this.markersByDispatch = {};
  }

  hideMarkers(dispatchIdExceptions: Array<string | number>) {
    const exceptions = new Set(dispatchIdExceptions.map(String));
    this.iterateDispatches((dispatchId, markers) => {
      if (!exceptions.has(String(dispatchId))) {
        markers.forEach((marker) => marker.setMap(null));
      }
    });
  }

  unhideMarkers(map: google.maps.Map) {
    this.iterateDispatches((_, markers) => {
      markers.forEach((marker) => marker.setMap(map));
    });
  }

  addMarker(dispatchId: string | number, marker: google.maps.Marker) {
    const existing = this.markersByDispatch[dispatchId] ?? [];
    this.markersByDispatch[dispatchId] = existing.concat(marker);
  }
}
